module.exports = __webpack_public_path__ + "img/tetrapack.44013762.svg";